export default __webpack_public_path__ + "static/media/ecgrow-logo-w.b9790bce.png";